import { render, staticRenderFns } from "./SetsWinLoseByType.vue?vue&type=template&id=013385f2&scoped=true&"
import script from "./SetsWinLoseByType.vue?vue&type=script&lang=js&"
export * from "./SetsWinLoseByType.vue?vue&type=script&lang=js&"
import style0 from "./SetsWinLoseByType.vue?vue&type=style&index=0&id=013385f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013385f2",
  null
  
)

export default component.exports